import { ProfileVisibilityField2 } from '@seek/profile-edit-ui';
import { useTranslations } from '@vocab/react';
import { Stack, Text } from 'braid-design-system';

import { LoadingItem } from 'src/components/LoadingItem/LoadingItem';
import { useAnalytics } from 'src/contexts/AnalyticsContext';
import {
  useGetProfileVisibility2,
  useGetProfileVisibilityOptions,
  useUpdateProfileVisibility2,
} from 'src/modules/graphql/visibility/data';
import { useGetLocale } from 'src/utils/useGetLocale/useGetLocale';

import translations from './.vocab';

const Loader = () => (
  <Stack space="medium">
    <Stack space="small">
      <LoadingItem size="standard" width="small" />
      <LoadingItem size="standard" width="full" />
    </Stack>
    <Stack space="small">
      <LoadingItem size="standard" width="small" />
      <LoadingItem size="standard" width="full" />
    </Stack>
    <Stack space="small">
      <LoadingItem size="standard" width="small" />
      <LoadingItem size="standard" width="full" />
    </Stack>
    <Stack space="small">
      <LoadingItem size="standard" width="small" />
      <LoadingItem size="standard" width="full" />
    </Stack>
  </Stack>
);

export const EditProfileVisibilitySettings = () => {
  const { t } = useTranslations(translations);
  const { profileVisibility2, loading, error } = useGetProfileVisibility2();
  const { updateProfileVisibility2 } = useUpdateProfileVisibility2();
  const { trackProfileVisibilityUpdated } = useAnalytics();
  const locale = useGetLocale();

  const { options, loading: optionsLoading } = useGetProfileVisibilityOptions();

  const onChangeFn = (newValue: string) => {
    updateProfileVisibility2({
      variables: {
        input: {
          id: newValue,
        },
        locale,
      },
    });

    trackProfileVisibilityUpdated(newValue.toLowerCase());
  };

  const showLoader =
    loading || error || optionsLoading || !options || options?.length === 0;

  return (
    <Stack space="small">
      <Text weight="strong">{t('Set visibility')}</Text>
      {showLoader ? (
        <Loader />
      ) : (
        <ProfileVisibilityField2
          onChange={(newValue) => onChangeFn(newValue)}
          options={options}
          value={profileVisibility2?.id || ''}
        />
      )}
    </Stack>
  );
};
